export default "__VITE_ASSET__BhrRH9qW__"